/* global SunergoPlatform */

class SPFormSumAmounts extends HTMLElement {
	connectedCallback() {
		this.form = this.closest('[data-form]');
		this.spForm = SunergoPlatform.forms[this.form.name];

		this.fixed = this.dataset.fixed || -1;
		this.compare = this.dataset.sumCompare;
		this.compareType = this.dataset.compareType || 'info';
		this.compareLabel = this.dataset.compareLabel;
		this.fieldId = this.dataset.sumFields;
		this.output = this.querySelector('output');
		this.currency = this.dataset.i18nCurrency;
		this.successMessage = this.dataset.successMessage;

		this.form.addEventListener('input', this.sumAmounts.bind(this));
		this.sumAmounts();
	}

	sumAmounts() {
		let total = 0;

		this.fields = this.form.querySelectorAll(`[data-sum-amount="${this.fieldId}"]`);
		this.fields.forEach(field => {
			total += parseFloat(field.value || 0);
		});

		this.output.value = this.fixed > -1 ? total.toFixed(this.fixed) : total;

		if (this.compare) this.compareAmounts();
	}

	compareAmounts() {
		const compareField = this.form.querySelector(`[name="${this.compare}"]`);
		if (!compareField) return;

		const total = parseFloat(this.output.value);
		const compare = parseFloat(compareField.value || 0);

		const difference = total - compare;

		const showMismatchMessage = (message) => {
			if (message) {
				let diffString = this.fixed > -1 ? Math.abs(difference).toFixed(this.fixed) : Math.abs(difference);
				let compareString = this.fixed > -1 ? compare.toFixed(this.fixed) : compare;

				if (this.currency) {
					diffString = `${this.currency}${diffString}`;
					compareString = `${this.currency}${compareString}`;
				}

				message = message.replace('[[difference]]', diffString);
				message = message.replace('[[value]]', compareString);
				message = message.replace('[[label]]', this.compareLabel ? ` (${this.compareLabel})`: '');
			}
			this.spForm.fieldFeedback.set(this.output.name, this.compareType, message);
		};

		if (difference > 0) {
			showMismatchMessage(this.dataset.i18nGreaterThan);
		} else if (difference < 0) {
			showMismatchMessage(this.dataset.i18nLessThan);
		} else {
			showMismatchMessage(false);
			
			if (this.successMessage)
				this.spForm.fieldFeedback.set(this.output.name, 'success', this.successMessage);

		}
	}
}

export default () => {
	customElements.define('sp-form-sum-amounts', SPFormSumAmounts);
};